import { Component, OnInit, Input } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Request } from "src/app/parametrage/core/model/request";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";
import { SubItemCheckedDTO } from "src/app/core/services/business/model/subItem-checked-dto";
import { UploadInPieceComponent } from "../../modal/upload-in-piece/upload-in-piece.component";
import { SubItem } from "src/app/core/services/business/model/sub-item";
import { OfficeViewerModalComponent } from "../../modal/viewer/office-viewer-modal/office-viewer-modal.component";
import { PdfViewerModalComponent } from "../../modal/viewer/pdf-viewer-modal/pdf-viewer-modal.component";
import { ImageViewerModalComponent } from "../../modal/viewer/image-viewer-modal/image-viewer-modal.component";
import { DocViewerModalComponent } from "../../modal/viewer/doc-viewer-modal/doc-viewer-modal.component";
import { RenommerFichierComponent } from "../../modal/renommer-fichier/renommer-fichier.component";
import { RemplacerFichierComponent } from "../../modal/remplacer-fichier/remplacer-fichier.component";

@Component({
  selector: "app-piece-client-update",
  templateUrl: "./piece-client-update.component.html",
  styleUrls: ["./piece-client-update.component.scss"],
})
export class PieceClientUpdateComponent implements OnInit {
  @Input() requestId: any;
  request: Request;

  pieces: SubItemCheckedDTO[];

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _activatedRoute: ActivatedRoute,
    private _gestionFichierService: GestionFichierService,
    private _requestService: RequestService
  ) {}

  ngOnInit() {
    this.getPiecesClient(this.requestId);
  }

  getPiecesClient(requestId) {
    this._gestionFichierService.getPiecesClient(requestId).subscribe(
      (data) => {
        this.pieces = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  downloadFile(subitemId: string, filename: string) {
    this._gestionFichierService.downloadFile(subitemId).subscribe((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

  upload(codeDocument) {
    const modalRef = this.modalService.open(UploadInPieceComponent, {
      centered: true,
      size: "lg",
    });

    modalRef.componentInstance.requestId = this.requestId;
    modalRef.componentInstance.codeDocument = codeDocument;
    if (codeDocument != "AUTRE") {
      modalRef.componentInstance.displayname = codeDocument;
    } else {
      modalRef.componentInstance.displayname = null;
    }

    modalRef.result.then(
      (data) => {
        // on close
        this.getPiecesClient(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  remplacerFichier(subitemId, name, displayname) {
    const modalRef = this.modalService.open(RemplacerFichierComponent, {
      centered: true,
    });
    modalRef.componentInstance.subitemId = subitemId;
    modalRef.componentInstance.codeDocument = name.split(".")[0];
    modalRef.componentInstance.displayname = displayname;

    modalRef.result.then(
      (data) => {
        // on close
        this.getPiecesClient(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  renommerFichier(subitemId) {
    const modalRef = this.modalService.open(RenommerFichierComponent, {
      centered: true,
    });
    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getPiecesClient(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  deleteFile(subItemId) {
    if (confirm("Press a button!")) {
      this._gestionFichierService.delete(subItemId).subscribe(
        (data) => {
          this.getPiecesClient(this.requestId);
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  /** */

  fileViewer(subitem: SubItem): void {
    const fileTab = subitem.name.split(".");
    const fileExtension = fileTab[fileTab.length - 1];

    if (fileExtension.toLowerCase() == "pdf") {
      this.pdfViewer(subitem.id);
    } else if (
      fileExtension.toLowerCase() == "png" ||
      fileExtension.toLowerCase() == "jpeg" ||
      fileExtension.toLowerCase() == "jpg"
    ) {
      this.imageViewer(subitem.id);
    } else {
      this.officeViewer(subitem.id);
    }
  }

  officeViewer(subitemId): void {
    const modalRef = this.modalService.open(OfficeViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  pdfViewer(subitemId): void {
    const modalRef = this.modalService.open(PdfViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  imageViewer(subitemId): void {
    const modalRef = this.modalService.open(ImageViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  docViewer(subitemId): void {
    const modalRef = this.modalService.open(DocViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
